export const ITEM_SEARCH_LIST_CONSTANT = {
  // csvファイル名
  CSV_FILENAME: 'item',
  // 合算項目値
  SUM_PLAN_NUM: 'sum_plan_num',
  // 対象テーブル
  TARGET_TABLE: 'event_information',
};
